import { useState, useEffect } from "react";
import api from "../../api/axiosConfig";
import "../../styles/Settings/CompanyProfile.css";

function CompanyProfile() {
  const [companyDetails, setCompanyDetails] = useState({
    name: "",
    companyregno: "",
    contactno: "",
    email: "",
    website: "",
    logo: "",
    address: "",
    about: "",
    social: {
      facebook: "",
      twitter: "",
      linkedin: "",
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (["facebook", "twitter", "linkedin"].includes(name)) {
      setCompanyDetails((prev) => ({
        ...prev,
        social: {
          ...prev.social,
          [name]: value,
        },
      }));
    } else {
      setCompanyDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/company-settings", companyDetails);
      alert("Company details saved successfully!");
    } catch (error) {
      console.error("Error saving company details:", error);
      alert("Error saving company details. Please try again.");
    }
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get("/api/company-settings");
        if (res.data) {
          setCompanyDetails((prev) => ({
            ...prev,
            ...res.data,
            social: {
              facebook: res.data?.social?.facebook || "",
              twitter: res.data?.social?.twitter || "",
              linkedin: res.data?.social?.linkedin || "",
            },
          }));
        }
      } catch (err) {
        console.error("Failed to fetch settings:", err);
      }
    };
    fetchSettings();
  }, []);

  return (
    <div className="company-profile-container">
      <form onSubmit={handleSubmit} className="company-profile-form">
        <div className="form-group">
          <label>Company Logo (URL)</label>
          <input
            type="text"
            name="logo"
            value={companyDetails.logo}
            onChange={handleChange}
            placeholder="https://example.com/logo.png"
          />
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>Company Name</label>
            <input
              type="text"
              name="name"
              value={companyDetails.name}
              onChange={handleChange}
              placeholder="e.g., ABC Pvt Ltd"
              required
            />
          </div>
          <div className="form-group">
            <label>Company Reg no</label>
            <input
              type="number"
              name="companyregno"
              value={companyDetails.companyregno}
              onChange={handleChange}
              placeholder="company reg no"
              required
            />
          </div>

          <div className="form-group">
            <label>Contact Number</label>
            <input
              type="text"
              name="contactno"
              value={companyDetails.contactno}
              onChange={handleChange}
              placeholder="e.g., +91-9876543210"
            />
          </div>

          <div className="form-group">
            <label>Website URL</label>
            <input
              type="text"
              name="website"
              value={companyDetails.website}
              onChange={handleChange}
              placeholder="https://www.company.com"
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={companyDetails.email}
              onChange={handleChange}
              placeholder="contact@company.com"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Company Address</label>
          <textarea
            name="address"
            value={companyDetails.address}
            onChange={handleChange}
            placeholder="Company full address..."
          />
        </div>

        <div className="form-group">
          <label>About the Company</label>
          <textarea
            name="about"
            value={companyDetails.about}
            onChange={handleChange}
            placeholder="Short description about your company..."
          />
        </div>

        <div className="social-section">
          <h4>Social Links</h4>
          <div className="form-grid">
            <div className="form-group">
              <label>Facebook</label>
              <input
                type="text"
                name="facebook"
                value={companyDetails.social.facebook}
                onChange={handleChange}
                placeholder="facebook.com/yourcompany"
              />
            </div>
            <div className="form-group">
              <label>Twitter</label>
              <input
                type="text"
                name="twitter"
                value={companyDetails.social.twitter}
                onChange={handleChange}
                placeholder="twitter.com/yourcompany"
              />
            </div>
            <div className="form-group">
              <label>LinkedIn</label>
              <input
                type="text"
                name="linkedin"
                value={companyDetails.social.linkedin}
                onChange={handleChange}
                placeholder="linkedin.com/company/yourcompany"
              />
            </div>
          </div>
        </div>

        <button type="submit" className="save-button">
          Save Details
        </button>
      </form>
    </div>
  );
}

export default CompanyProfile;
